const waitTurnMessage: string = 'Wait your turn...'

export default waitTurnMessage
